"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mediaQueries = exports.modalStyles = exports.colors = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// non-contextual colors
var white = "#FFFFFF";
var black = "#000000";
var colors = {
  black: black,
  white: white,
  grey: "#A4ABAE",
  // darker grey seen in most of the 'grey' icons
  lightGrey: "#E4E7ED",
  // lighter grey - seen in icons like "Score rest" in Zoom
  primary: "#34A3E7",
  // Picton Blue (blue)
  primaryHalfOpacity: "rgba(52, 163, 231, 0.5)",
  // Picton Blue (blue) - half opacity)
  primaryHover: "#50c0f4",
  primaryActive: "#3090df",
  primaryDarker: "#4195D3",
  success: "#9ED16B",
  // Feijoa (green)
  error: "#EC673F",
  // Burnt Sienna (red)
  yellow: "#FBCF10",
  // Rosetta Stone Brand color yellow
  confirm: "#95D951",
  unusedBackground: "#F1F1F1",
  unusedTextColor: "#84898E"
};
exports.colors = colors;
var modalStyles = {
  promptDialogueBackground: white,
  modalDialogZIndex: 7000,
  modalBackdrop: "#0A1D37",
  // @FIXME - need to find a way to encorporate these into zoom z-index regristry
  modalBackdropUnderFooterZIndex: 5006,
  modalBackdropOverFooterZIndex: 5008
};
exports.modalStyles = modalStyles;
var mediaQueries = {
  chromebook: "@media only screen and (max-height: 768px)"
};
exports.mediaQueries = mediaQueries;

var _default = _objectSpread(_objectSpread(_objectSpread({}, colors), modalStyles), mediaQueries);

exports["default"] = _default;